

















































































































import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import Tinymce from "@/components/Tinymce/index.vue";
import Ueditor from "@/components/Ueditor/index.vue";
import { ElForm } from "element-ui/types/form";
import moment from "moment";
import api from "@/api";
import {
  ActivityCreateOrUpdateDto,
  AttachmentHostType,
} from "@/api/appService";
import SimpleUploadImage from "@/components/SimpleUploadImage/index.vue";
import { regionData, CodeToText } from "element-china-area-data";
import BaiduMap from "vue-baidu-map/components/map/Map.vue";

Vue.use(regionData, CodeToText);
@Component({
  components: { SimpleUploadImage, Tinymce, Ueditor, BaiduMap },
})
export default class EditActivity extends Vue {
  @Ref() readonly dataForm!: ElForm;
  private activityDate: any = [];

  @Watch("form.place")
  changeMap(val: any) {
    //this.address_detail += val
    this.address_detail = this.provincecityarea + val;
    this.setPlace();
  }

  selectedOptions: any[] = ["320000", "320500", "320507"];
  options: object = regionData;
  address_detail: string = "";
  userlocation: any = {
    lng: undefined,
    lat: undefined,
  };
  serviceTime: any = 0;

  zoom: number = 13;
  BMap: any;
  map: any;

  provincecityarea: string = "";
  btnDisabled:boolean = false;

  get dialogTitle() {
    return this.form!.id ? `编辑 ${this.form.title}` : "新建";
  }

  get hostType() {
    return AttachmentHostType.Activity;
  }

  async created() {
    console.log(this.$route.params.id);
    if (this.$route.params.id) {
      this.dataId = Number(this.$route.params.id);

      await api.activity.getForEdit({ id: this.dataId }).then((res) => {
        this.form = res.data!;

        this.selectedOptions = [
          res.data!.provinceId + "",
          res.data!.cityId + "",
          res.data!.areaId + "",
        ];
      });
    }
    this.$nextTick(() => {
      this.dataForm.clearValidate();
    });
  }

  defaultData: ActivityCreateOrUpdateDto = {
    id: 0,
  };

  activityTypes: any[] = [
    { label: "普通活动", value: 0 },
    { label: "志愿者活动", value: 1 },
  ];

  applyTimeTypes: any[] = [
    { label: "默认活动截止时间", value: 0 },
    { label: "自定义", value: 1 },
  ];

  show = false;
  form: any = { ...this.defaultData };

  async save(isPublish: boolean) {
    this.btnDisabled = true;
    this.dataForm.validate(async (valid: boolean) => {
      if (valid) {
        this.form.isPublish = isPublish;
        if (this.form!.id) {
          await api.activity.update({ body: this.form });
        } else {
          await api.activity.create({ body: this.form });
        }
        this.$router.back();
      } else {
        this.$message.error("请检查表单！");
        this.btnDisabled = false;
      }
    });
  }

  cancel() {
    this.$router.back();
  }

  get dd() {
    return [this.form!.activityStartTime, this.form!.activityEndTime];
  }

  set dd(e) {
    if (e && e.length === 2) {
      console.log(e);
      this.form!.activityStartTime = moment(e[0]).format("YYYY-MM-DD HH:mm:ss");
      this.form!.activityEndTime = moment(e[1]).format("YYYY-MM-DD HH:mm:ss");
    }
  }

  get t1() {
    return moment(this.form!.activityStartTime).format("HH:mm");
  }
  set t1(e) {
    if (e) {
      let _t = e.split(":");
      this.form!.activityStartTime = moment(this.form!.activityStartTime)
        .hour(parseInt(_t[0]))
        .minute(parseInt(_t[1]))
        .format("YYYY-MM-DD HH:mm:ss");
      console.log(this.form!.activityStartTime);
    }
  }
  get t2() {
    return moment(this.form!.activityEndTime).format("HH:mm");
  }
  set t2(e) {
    if (e) {
      let _t = e.split(":");
      this.form!.activityEndTime = moment(this.form!.activityEndTime)
        .hour(parseInt(_t[0]))
        .minute(parseInt(_t[1]))
        .format("YYYY-MM-DD HH:mm:ss");
      console.log(this.form!.activityEndTime);

      let difDays = moment(this.form!.activityEndTime).diff(
        moment(this.form!.activityStartTime),
        "days"
      );
      let difMin = moment(this.form!.activityEndTime).diff(
        moment(this.form!.activityStartTime),
        "minutes"
      );

      console.log(`difDays:${difDays},difMin:${difMin}`);

      this.form.totalHours = (difMin - difDays * 24 * 60) / 60;
    }
  }

  //   省市区
  handleChange(value: any, label: any) {
    this.form!.provinceId = value[0];
    this.form!.cityId = value[1];
    this.form!.areaId = value[2];
    this.address_detail =
      CodeToText[value[0]] + CodeToText[value[1]] + CodeToText[value[2]];
    this.provincecityarea =
      CodeToText[value[0]] + CodeToText[value[1]] + CodeToText[value[2]];
    this.setPlace();
  }

  map_handler(result: any) {
    this.BMap = result.BMap;
    this.map = result.map;
  }

  //地址
  setPlace() {
    let th = this;

    if (this.map) {
      this.map.clearOverlays(); //清除地图上所有覆盖物

      function myFun() {
        if (local && local.getResults().getPoi(0)) {
          console.log(local.getResults().getPoi(0));
          th.userlocation = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
          th.map.centerAndZoom(th.userlocation, 18);
          th.map.addOverlay(new th.BMap.Marker(th.userlocation)); //添加标注
          th.form!.placeCoordinate =
            "" + th.userlocation.lng + "," + th.userlocation.lat;
        }
      }

      let local = new th.BMap.LocalSearch(th.map, {
        //智能搜索
        onSearchComplete: myFun,
      });
      local.search(th.address_detail);
      console.log(th.address_detail);
      th.map.addEventListener("click", function (e: any) {
        th.form!.placeCoordinate =
          "" + th.userlocation.lng + "," + th.userlocation.lat;
      });
    }
  }

  roleRule = {
    title: [
      {
        required: true,
        message: "活动标题 必填",
        trigger: "blur",
      },
    ],
    titleImagePath: [
      {
        required: true,
        message: "活动封面图片 必须上传",
        trigger: "blur",
      },
    ],
    content: [
      {
        required: true,
        message: "活动内容 必填",
        trigger: "blur",
      },
    ],
    typeID: [
      {
        required: true,
        message: "活动类型 必选",
        trigger: "blur",
      },
    ],
    areaId: [
      {
        required: true,
        message: "活动地区 必填",
        trigger: "blur",
      },
    ],
    place: [
      {
        required: true,
        message: "详细地址 必填",
        trigger: "blur",
      },
    ],
    totalHours: [
      {
        required: true,
        message: "请正确选择活动时间",
        trigger: "blur",
      },
    ],
    aimAmount: [
      {
        required: true,
        message: "必填",
        trigger: "blur",
      },
    ],
  };
}
